import { resolveId } from '@medplum/core'
import type { Observation, Reference } from '@medplum/fhirtypes'
import { formatDate } from '@seen/core/dates'
import { ExtendedObservation } from '@seen/core/models/observation'
import { cn } from '@seen/ui'
import { IconFlask } from '@tabler/icons-react'
import type { JSX } from 'react'
import { Link } from '#src/components/core/Link.tsx'
import { useRead } from '#src/hooks/useRead.ts'

export function ObservationMention({
  observation,
  className,
  displayOverride,
}: {
  observation: Reference<Observation>
  className?: string
  /* Replaces the reading and its date, as a citation chip does: the quote
   * beside it already carries the value. */
  displayOverride?: string | null
}): JSX.Element {
  const { data: obs } = useRead(ExtendedObservation, observation)
  const participantId = resolveId(obs?.subject)
  const observationId = resolveId(observation)
  const observationUrl =
    participantId && observationId
      ? `/Patient/${participantId}/observations/${observationId}`
      : undefined

  return (
    <Link
      to={observationUrl ?? '#'}
      className={cn(
        'select-none rounded-sm border-[0.5px] border-gray-450 bg-gray-470 box-decoration-clone px-1 py-px hover:bg-gray-460 group-[.ProseMirror-selectednode]:bg-[lch(53_52.26_286.91/0.4)] [&&]:no-underline',
        className
      )}
      tabIndex={-1}
      aria-disabled={!observationUrl}
    >
      <span>
        <IconFlask className="inline-block size-[1em] align-[-0.25ex]" />
      </span>
      {displayOverride ? (
        <span> {displayOverride}</span>
      ) : (
        <span>
          {' '}
          {obs?.display}
          {obs && (
            <span className="text-muted-foreground">
              : {obs.valueDisplay ?? ''}
              {obs.effectiveDateTime
                ? ` · ${formatDate(obs.effectiveDateTime)}`
                : ''}
            </span>
          )}
        </span>
      )}
    </Link>
  )
}
